import { Injectable } from '@angular/core';
import { Usuario } from '../models/usuario.model';

//Servicios
import { UsuarioService } from './usuario.service';

// Modelos
import { Aspirante } from '../models/aspirante.model';
import { EventService } from './event.service';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {
    user: Usuario;


    constructor(private usuarioService: UsuarioService, private eventService: EventService) {
    }

    /**
     * Returns the current user
     */
    public currentUser(): Usuario {
      return this.usuarioService.usuario;
    }

    public EstaLogueado(): boolean {
      return this.usuarioService.EstaLogueado();
    }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(email: string, password: string) {
      this.user = new Usuario();
      this.user.S00USR = email;
      this.user.S00CLA = password;
      return this.usuarioService.Login( this.user );
    }

    // almora 2026.03.14 Login con Microsoft Entra-ID 
    LoginMicrosoft (params : any) {
      return this.usuarioService.LoginMicrosoft ( params );
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(aspirante: Aspirante) {
      return this.usuarioService.CrearCuenta (aspirante);
    }

    solicitud(aspirante: Aspirante) {
      return this.usuarioService.CrearSolicitudClave (aspirante);
    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(email: string) {
//        return getFirebaseBackend().forgetPassword(email).then((response: any) => {
  //          const message = response.data;
    //        return message;
      //  });
      return  Promise.resolve(true);

    }

    ActivarCuenta(sooema:string,s00cla:string, s34con: string, pad17con:string, pad10cod:string, pad17num:string){
      return this.usuarioService.ActivarCuenta( sooema, s00cla, s34con, pad17con,pad10cod, pad17num );
    }

    /**
     * Logout the user
     */
    logout() {
      this.usuarioService.Salir ()
        .subscribe( correcto => {
      this.eventService.cerrarTabs();
        },
        error  => {
          alert(error);
        }
       );
    }
}

